import styled from '@emotion/styled';
import React from 'react';

const Wrapper = styled.div`
  position: relative;
`;

const StyledWarningIcon = styled.svg`
  position: absolute;
  left: -16px;
  top: 22px;
`;

export const Warning = (props: { fill?: string }) => {
  return (
    <Wrapper>
      <StyledWarningIcon
        {...(props.fill ? { fill: props.fill } : {})}
        width='24'
        height='24'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M12.5 10.6025H10V11.6025H11.5V15.6025H10V16.6025H14V15.6025H12.5V10.6025Z' />
        <path d='M12.5 8.10254H11.5V9.10254H12.5V8.10254Z' />
        <path d='M12 2.60254C6.48 2.60254 2 7.08254 2 12.6025C2 18.1225 6.48 22.6025 12 22.6025C17.52 22.6025 22 18.1225 22 12.6025C22 7.08254 17.52 2.60254 12 2.60254ZM12 21.6025C7.04 21.6025 3 17.5625 3 12.6025C3 7.64254 7.04 3.60254 12 3.60254C16.96 3.60254 21 7.64254 21 12.6025C21 17.5625 16.96 21.6025 12 21.6025Z' />
      </StyledWarningIcon>
    </Wrapper>
  );
};
